import React from 'react';
import Helmet from 'react-helmet';

import Layout from '../components/Layout';
import Container from '../components/Container';
import ContactUs from '../components/ContactUs';

const PrivacyPage = () => {
  return (
    <Layout pageName="privacy-policy">
      <Helmet>
      {/* Global site tag (gtag.js) - Google Analytics */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=UA-118777783-1"></script>
      <script type="text/javascript">
        {`window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', 'UA-118777783-1');`}
      </script>
      {/* <!-- Google Tag Manager --> */}
      <script type="text/javascript">{`
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-N8NWRND');
      `}</script>
      {/* <!-- End Google Tag Manager --> */}
      {/* <!-- Google tag (gtag.js) --> */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-20D2B15V4Y"></script>
      <script>
        {`window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', 'G-20D2B15V4Y');`}
      </script>
      </Helmet>
      {/* <!-- Google Tag Manager (noscript) --> */}
      <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-N8NWRND"
      height="0" width="0" style={{display:'none', visibility:'hidden' }}></iframe></noscript>
      {/* <!-- End Google Tag Manager (noscript) --> */}
      <Container>
        <div className="privacy-content">
          <div className="main-heading large-font">
            Privacy Policy and Cookie Usage
          </div>
          <div className="small-font">
            When you use Meetrix services, you’re trusting us with your
            information. We understand this is a big responsibility and work
            hard to protect your information and put you in control.
            <br />
            This Privacy Policy is meant to help you understand what information
            we collect, why we collect it, and how you can update, manage,
            export, and delete your information.
          </div>
          <div className="gray-text-small">KEEPING YOUR INFORMATION SECURE</div>

          <div className="medium-font heading">
            We build security into our services to protect your information
          </div>
          <div className="small-font">
            All Meetrix products are built with strong security features that
            continuously protect your information. The insights we gain from
            maintaining our services help us detect and automatically block
            security threats from ever reaching you.
            <br />
            We work hard to protect you from unauthorized access, alteration,
            disclosure, or destruction of information we hold, including:
            <ul>
              <li>
                We use encryption to keep your data private while in transit
              </li>
              <li>
                We review our information collection, storage, and processing
                practices to prevent unauthorized access to our systems
              </li>
              <li>
                We restrict access to personal information to Meetrix employees,
                contractors, and agents who need that information in order to
                process it. Anyone with this access is subject to strict
                contractual confidentiality obligations and may be disciplined
                or terminated if they fail to meet these obligations
              </li>
            </ul>
          </div>

          <div className="medium-font heading">What data we collect</div>
          <div className="small-font">
            The personal data we collect from you includes:
            <ul>
              <li>
                Questions, queries or feedback you leave, including your email
                address if you contact Meetrix Technologies
              </li>
              <li>
                Your email address and subscription preferences when you sign up
                to our email alerts
              </li>
              <li>
                How you use our emails - for example whether you open them and
                which links you click on
              </li>
              <li>
                Your Internet Protocol (IP) address, and details of which
                version of web browser you used
              </li>
              <li>
                Information on how you use the site, using cookies and page
                tagging techniques
              </li>
            </ul>
          </div>

          <div className="medium-font heading">Why we need your data</div>
          <div className="small-font">
            We collect information through Google Analytics to see how you use
            the site and digital services. We do this to help:
            <ul>
              <li>Make sure the site is meeting the needs of its users</li>
              <li>Make improvements, for example improving site search</li>
            </ul>
          </div>

          <div className="medium-font heading">
            We also collect data in order to:
          </div>
          <div className="small-font">
            <ul>
              <li>
                Gather feedback to improve our services, for example our email
                alerts
              </li>
              <li>
                Respond to any feedback you send us, if you’ve asked us to
              </li>
              <li>Send email alerts to users who request them</li>
              <li>
                Allow you to access Meetrix services and make transactions
              </li>
              <li>Provide you with information about local services</li>
              <li>Monitor use of the site to identify security threats</li>
            </ul>
          </div>

          <div className="medium-font heading">What we do with your data</div>
          <div className="small-font">
            The data we collect may be shared with other government departments,
            agencies and public bodies. It may also be shared with our
            technology suppliers, for example our hostingprovider.
            <br />
            We will not:
            <ul>
              <li>Sell or rent your data to third parties</li>
              <li>Share your data with third parties for marketing purposes</li>
            </ul>
            We will share your data if we are required to do so by law - for
            example, by court order, or to prevent fraud or other crime.
          </div>

          <div className="medium-font heading">How long we keep your data</div>
          <div className="small-font">
            We will only retain your personal data for as long as:
            <ul>
              <li>It is needed for the purposes set out in this document</li>
              <li>The law requires us to</li>
            </ul>
            We will keep your email data until you unsubscribe. We will keep
            your feedback data for indefinitely.
          </div>

          <div className="medium-font heading">
            Children’s privacy protection
          </div>
          <div className="small-font">
            Our services are not designed for, or intentionally targeted at,
            children 13 years of age or younger. We do not intentionally collect
            or maintain data about anyone under the age of 13.
          </div>

          <div className="medium-font heading">
            Where your data is processed and stored
          </div>
          <div className="small-font">
            We design, build and run our systems to make sure that your data is
            as safe as possible at all stages, both while it’s processed and
            when it’s stored.
            <br />
            All personal data is stored in the US. Data collected by Google
            Analytics data may be transferred on to their own servers.
          </div>

          <div className="medium-font heading">
            How we protect your data and keep it secure
          </div>
          <div className="small-font">
            We are committed to doing all that we can to keep your data secure.
            We have set up systems and processes to prevent unauthorised access
            or disclosure of your data - for example, we protect your data using
            varying levels of encryption.
            <br />
            We also make sure that any third parties that we deal with keep all
            personal data they process on our behalf secure.
          </div>

          <div className="cookies-section">
            <div className="medium-font heading">Cookies on MEETRIX.IO</div>
            <div className="small-font">
              Cookies are files saved on your phone, tablet or computer when you
              visit a website.
              <br />
              We use cookies to store information about how you use the
              MEETRIX.IO website, such as the pages you visit.
            </div>
            <div className="medium-font heading">Cookie settings</div>
            <div
              className="small-font"
              style={{ borderBottom: '1.2px solid', margin: '10px 0' }}
            >
              We use 3 types of cookies
            </div>
            <ul className="ul-heading">
              <li className="medium-font heading">
                Cookies that measure website use
              </li>
              <div className="small-font">
                We use Google Analytics to measure how you use the website so we
                can improve it based on user needs. We do not allow Google to
                use or share the data about how you use this site.
                <br />
                Google Analytics sets cookies that store anonymised information
                about:
              </div>
              <ul className="small-font">
                <li>How you got to the site</li>
                <li>
                  The pages you visit on MEETRIX.IO and our digital services,
                  and how long you spend on each page
                </li>
                <li>What you click on while you're visiting the site</li>
              </ul>
            </ul>
            <ul className="ul-heading">
              <li className="medium-font heading">
                Cookies that help with our communications and marketing
              </li>
              <div className="small-font">
                These cookies may be set by third party websites and do things
                like measure how you view YouTube videos that are on MEETRIX.IO.
              </div>
            </ul>
            <ul className="ul-heading">
              <li className="medium-font heading">
                Cookies that remember your settings
              </li>
              <div className="small-font">
                These cookies do things like remember your preferences and the
                choices you make, to personalise your experience of using the
                site.
              </div>
              <div className="small-font">
                Essential cookies do things like remember your progress through
                a form (for example a licence application)
              </div>
              <div className="small-font">They always need to be on.</div>
            </ul>
          </div>
          <div className="medium-font heading">
            Contact us or make a complaint
          </div>
          <div className="small-font">
            Contact the Privacy Team if you:
            <ul>
              <li>Have a question about anything in this privacy notice</li>
              <li>
                Think that your personal data has been misused or mishandled
              </li>
            </ul>
          </div>

          <div className="small-font heading">Privacy Team</div>
          <a href="mailto:hello@meetrix.io" target="_blank" rel="noopener">
            hello@meetrix.io
          </a>

          <div className="medium-font heading">Changes to this policy</div>
          <div className="small-font">
            We may change this privacy policy. In that case, the ‘last updated’
            date at the bottom of this page will also change. Any changes to
            this privacy policy will apply to you and your data immediately.
          </div>
          <div className="small-font" style={{ marginTop: '10px' }}>
            Last updated 31 May 2020
          </div>
        </div>
      </Container>
    </Layout>
  );
};

export default PrivacyPage;
